import { render } from "./admin-order-proposal-list.vue?vue&type=template&id=4109518a&scoped=true&ts=true"
import script from "./admin-order-proposal-list.vue?vue&type=script&lang=ts"
export * from "./admin-order-proposal-list.vue?vue&type=script&lang=ts"

import "./admin-order-proposal-list.vue?vue&type=style&index=0&id=4109518a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4109518a"]])

export default __exports__